import { Common } from '@stockbit/ui';
import { Skeleton } from 'antd';
import { BoxContainer } from './styled';
import { DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_LOADING } from './__tests__/constant';

const { Flex } = Common;

function Loading() {
  return (
    <BoxContainer data-cy={DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_LOADING}>
      <Flex direction="column" align="center">
        <Skeleton.Avatar active size={70} style={{ marginBottom: '8px' }} />
        <Skeleton.Input size="small" active style={{ width: 70, height: 17 }} />
        <Skeleton.Input size="small" active style={{ width: 90, height: 14 }} />
      </Flex>
      <Skeleton.Input size="small" active style={{ width: 70 }} />
    </BoxContainer>
  );
}

export default Loading;
